// Hook odpowiedzialny za pobranie url resolvera

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

// parametry requestu do api
export type IRequest = {
  urlKey: string;
  fromLanguage: string;
  toLanguage: string;
};

export interface IResponse {
  url_shortcut: string;
  page_type: 'PRODUCTS' | 'PRODUCT' | 'CMS_PAGE' | 'HOME_PAGE';
  parameters: string;
}

const getLayoutUrlResolverToLanguage = (params?: IRequest): Promise<IResponse> => {
  return axios.get('/layout/url_resolver-to-language', {
    params,
    headers: { 'Content-Language': params?.fromLanguage || '' }
  });
};
export const useGetLayoutUrlResolverToLanguage = (
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((params: IRequest) => getLayoutUrlResolverToLanguage(params), options);
